(() => {
  if (window.__pawcareFooterEventsBound) return;
  window.__pawcareFooterEventsBound = true;

  const push = (payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pc-footer-section] a[data-pc-track]');
    if (!link) return;

    const footer = link.closest('[data-pc-footer-section]');
    const label = (link.textContent || '').replace(/\s+/g, ' ').trim();

    push({
      event: 'pc_footer_link_click',
      pc_footer_section_id: footer?.dataset.pcFooterSection || '',
      pc_footer_link_type: link.dataset.pcTrack || 'navigation',
      pc_footer_area: link.dataset.pcFooterArea || 'unspecified',
      pc_footer_link_text: label,
      pc_footer_destination_url: link.href
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-pc-footer-section] .pc-footer__newsletter-form');
    if (!form) return;

    const footer = form.closest('[data-pc-footer-section]');

    push({
      event: 'pc_footer_newsletter_submit',
      pc_footer_section_id: footer?.dataset.pcFooterSection || '',
      pc_footer_area: 'newsletter'
    });
  });
})();
